<template>
  <div class="DownloadContractBox">
    <div class="TopTitle">
      <div class="Title">合同下载</div>
    </div>
    <div class="BottomTable">
      <Commontable ref="refTableQuota" :loadingTable="loadingTableContract" @CZClick="CZClick" :FromUploadSetting="FromUploadSetting" @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination ref="Pagination" type='allColor' @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom :width="DialogFromWidth" :title="TitleDialog" :rigthText="rigthText" :dialogVisible="dialogVisibDialogAll" @cancel="cancelDialogAll" @dialogOK="dialogOKDialogAll">
      <div style="margin-left: -10px;">
        <CommonbtnUpLoad v-show="TitleDialog == '上传提交'" types='UploadAll' style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="上传" fontSize="14px" @getFile="UpLoadProcurementIndicators" :src="require('@/assets/icon/icon-drjys.png')">
        </CommonbtnUpLoad>
      </div>
      <FilesAndPictures :DelFlag="false" v-for="(item , index) of lstAttachment" :key="index" :fileAddImgData="item" @See="See"></FilesAndPictures>
    </DialogFrom>
    <Picturepreview :imgsrc="imgsrc" :show="imgShow" @hidefn="imgHide"></Picturepreview>
  </div>

</template>

<script>
import Commontable from '@/components/common-table.vue'
import Pagination from '@/components/pagination.vue'
import headerData from './headerData/headerData'
import DialogFrom from '@/components/dialog-from.vue'
import CommonbtnUpLoad from '@/components/common-upload.vue'
import FilesAndPictures from '@/components/FilesAndPictures.vue'
import Picturepreview from '@/components/picturepreview.vue'
import {
  CustomerContractList,
  CustomerContractUpLoadAttachment,
  CustomerContractSignContract 
} from '@/api/channel'
export default {
  components: {
    Commontable,
    Pagination,
    DialogFrom,
    CommonbtnUpLoad,
    FilesAndPictures,
    Picturepreview
  },
  props: {},
  data() {
    return {
      loadingTableContract: false,
      dialogVisibDialogAll: false,
      imgShow: false,
      TitleDialog: '加载中...',
      rigthText: '加载中...',
      DialogFromWidth: '500px',
      imgsrc: '',
      PageIndex: 1,
      pageSize: 10,
      total: 0,
      rowData: null,
      FromUploadSetting: {
        accept: '*',
        multiple: true
      },
      tableData: [],
      headerData: [],
      lstAttachment: []
    }
  },
  created() {
    this.CustomerContractList()
  },
  mounted() {
    this.headerData = JSON.parse(JSON.stringify(headerData))
  },
  activated() { },
  updated() { },
  methods: {
    // 列表
    async CustomerContractList() {
      let {
        code,
        data,
        message
      } = await CustomerContractList({
        PageSize: this.pageSize,
        PageIndex: this.PageIndex
      })
      if (code == 0) {
        this.total = data.Count

        data.data.forEach((item, index) => {
          let czAll =
            [
              {
                title: '上传',
                clickName: 'NoUpload',
                BtnFalg: true
              },
              {
                title: '下载',
                clickName: 'download',
                BtnFalg: true
              },
            ]
          item['czAll'] = czAll
        })
        this.tableData = data.data
      } else {
        this.$message.warning(message)
      }
    },
    // 上传文件
    async CustomerContractUpLoadAttachment(file) {
      const loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let formData = new FormData()
      formData.append("file", file)
      let res = await CustomerContractUpLoadAttachment(formData)
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.lstAttachment = []
        this.lstAttachment.push(res.data)
      } else if (res.code == 101) {
        this.$message({
          type: 'warning',
          message: res.message
        })
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }
      loading.close();
    },
    // 提交
    async CustomerContractSignContract(){
      let {
        code,
        data,
        message
      } = await CustomerContractSignContract({
        ContractID: this.rowData.ContractID,
        FileName: this.lstAttachment[0].FileName
      })
      if(code == 0){
        this.$message.success(message)
        this.dialogVisibDialogAll = false
        this.CustomerContractList()
      } else {
        this.$message.warning(message)
      }
    },
    CZClick(obj) {
      this.rowData = obj.row
      if (obj.item.title == '下载') {
        if (obj.row.FileUrl) {
          window.open(obj.row.FileUrl, '_blank')
          // window.location.href = obj.row.ContractFileUrl
        } else {
          this.$message.warning("请先上传需要下载的文件！")
        }
      } else if (obj.item.title == '上传') {
        this.dialogVisibDialogAll = true
        this.TitleDialog = '上传提交'
        this.rigthText = '提交'
        this.DialogFromWidth = '500px'
      }
      console.log(obj);
    },
    UpLoadProcurementIndicators(file) {
      this.CustomerContractUpLoadAttachment(file)
    },
    See(par) {
      console.log(par);
      if (par.Extension == 'jpg' || par.Extension == 'png' || par.Extension == 'gif') {
        this.imgShow = true
        this.imgsrc = par.FileUrl
      } else if (par.Extension == 'pdf') {
        window.open(par.FileUrl, '_blank')
      } else {
        window.location.href = par.FileUrl
      }
    },
    imgHide() {
      this.imgShow = false
    },
    onRowClick(val) {
      this.rowData = val
      console.log(val);
    },

    handleCurrentChange(PageIndex) {
      this.PageIndex = PageIndex
      this.CustomerContractList()
    },
    handleSizeChange(PageSize) {
      this.pageSize = PageSize
      this.CustomerContractList()
    },
    cancelDialogAll() {
      this.dialogVisibDialogAll = false
    },
    dialogOKDialogAll() {
      if (this.TitleDialog == '上传提交') {
        this.CustomerContractSignContract()
      } 
    },
  },
  computed: {},
  watch: {
    dialogVisibDialogAll: {
      handler(newDialogAll, oldDialogAll) {
        if (newDialogAll) {
          if (this.TitleDialog == '上传提交') {
            this.lstAttachment = []
          }
        }
      },
      deep: true,
      immediate: true
    },
  },
}
</script>
<style scoped lang='less'>
.DownloadContractBox {
  width: 98%;
  //   height: 150px;
  //   border: 1px solid red;
  margin: 0px 5px 0px auto;

  .TopTitle {
    height: 55px;
    width: 100%;
    border-bottom: 1px solid #eaecef;
    position: relative;
    // border: 1px solid red;

    .Title {
      height: 45px;
      width: 100%;
      line-height: 45px;
      font-size: 16px;
      font-weight: 500;
      color: #16181a;
      display: inline;
    }
  }

  .BottomTable {
    width: 101%;
    margin-left: -10px;
    margin-top: 16px;
  }
}
</style>